import { Action } from "../../types";

const initialState: any = {
  appType: localStorage.getItem("rolappTypee")
    ? JSON.parse(localStorage.getItem("rolappTypee")!)
    : {
        id: "",
        label: "",
        designations: [],
      },
};

export function appTypeReducer(
  state: any = initialState,
  action: Action<any>
): any {
  switch (action.type) {
    case "setCurrentAppType":
      const updateAppType = action.payload;
      localStorage.setItem("rolappTypee", JSON.stringify(updateAppType));
      return {
        ...state,
        appType: action.payload,
      };
    default:
      return state;
  }
}
